import { PageProps, ModalProps } from "./types";

export const PageContainer = ({ children, title }: PageProps) => {
  return (
    <div className="w-full col-6 bg-white rounded-lg border border-gray-200 p-6">
      <span className="satoshi-xl-bold-pry-900">{title}</span>
      {children}
    </div>
  );
};

export const ModalContainer = ({ title, children, closeIcon }: ModalProps) => {
  return (
    <div className="fixed z-70 inset-0 size-full bg-black/20 backdrop-blur-md grid place-content-center">
      <div className="w-full min-w-[536px] max-h-[90vh] overflow-hidden col-8 bg-white dark:bg-[#1E1E1E]  rounded-lg border border-gray-200 dark:border-[#FFFFFF1A] p-6">
        <div className="row-4 justify-between">
          <span className="satoshi-xl-bold-pry-900 dark:text-white">
            {title}
          </span>
          {closeIcon && closeIcon}
        </div>
        <div className="overflow-y-auto px-6">{children}</div>
      </div>
    </div>
  );
};
